var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.presential_seats.length === 0 &&
      !_vm.presential_event_using_presential_catalog &&
      !_vm.loading_seats
        ? _c("q-table", {
            staticClass: "q-mt-md",
            attrs: {
              data: _vm.users_invited,
              columns: _vm.columns_users_invited,
              pagination: _vm.server_pagination,
              selection: "multiple",
              selected: _vm.users_invited_selected,
              loading: _vm.loading,
              filter: _vm.filter_guests,
              "row-key": "user_id",
              "no-data-label": _vm.$t("no_data_avaliable"),
              "no-results-label": _vm.$t("no_results_found"),
              "loading-label": _vm.$t("loading_data"),
              "rows-per-page-label": _vm.$t("items_per_page"),
              "rows-per-page-options": [5, 10, 50, 100],
              "binary-state-sort": ""
            },
            on: {
              "update:pagination": function($event) {
                _vm.server_pagination = $event
              },
              "update:selected": function($event) {
                _vm.users_invited_selected = $event
              },
              request: _vm.requestGuests
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "top",
                  fn: function(props) {
                    return [
                      _c("q-input", {
                        attrs: {
                          "float-label": _vm.$t("guests_quantity"),
                          dense: "",
                          disable: "",
                          readonly: ""
                        },
                        model: {
                          value: _vm.qtyGuestsInvited,
                          callback: function($$v) {
                            _vm.qtyGuestsInvited = $$v
                          },
                          expression: "qtyGuestsInvited"
                        }
                      }),
                      _c("div", { staticClass: "col" }),
                      _c("q-search", {
                        staticClass: "q-mr-md",
                        attrs: {
                          debounce: 600,
                          icon: "far fa-search",
                          placeholder: _vm.$t("search")
                        },
                        model: {
                          value: _vm.filter_guests,
                          callback: function($$v) {
                            _vm.filter_guests = $$v
                          },
                          expression: "filter_guests"
                        }
                      }),
                      _c("q-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.permissions.subscribe_event_users &&
                              _vm.users_invited.length > 0,
                            expression:
                              "permissions.subscribe_event_users && users_invited.length > 0"
                          }
                        ],
                        staticClass: "q-mr-md",
                        attrs: {
                          color: "tertiary",
                          icon: "far fa-file-download",
                          label: _vm.$t("download_guest_list"),
                          disable: _vm.users_invited.length < 1
                        },
                        on: { click: _vm.downloadGuestList }
                      }),
                      _c("q-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.permissions.subscribe_event_users &&
                              _vm.users_invited_selected.length > 0,
                            expression:
                              "permissions.subscribe_event_users && users_invited_selected.length > 0"
                          }
                        ],
                        staticClass: "q-mr-sm",
                        attrs: {
                          color: "negative",
                          icon: "far fa-ban",
                          label: _vm.$t("remove"),
                          disable: _vm.disableGuests
                        },
                        on: { click: _vm.confirmRemoveGuests }
                      }),
                      _c(
                        "q-btn",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.canImportGuests,
                              expression: "canImportGuests"
                            }
                          ],
                          staticClass: "q-mr-md",
                          attrs: {
                            color: "secondary",
                            icon: "far fa-plus",
                            label: _vm.$t("import_guests"),
                            disable:
                              _vm.disableGuests ||
                              _vm.users_invited.length >= _vm.max_participants
                          },
                          on: { click: _vm.showImportGuests }
                        },
                        [
                          !_vm.first_event_date
                            ? _c("q-tooltip", [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "there_are_no_events_for_this_training_yet"
                                      )
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ])
                            : _vm._e(),
                          _vm.permissions.subscribe_event_users &&
                          _vm.subscription_restrictions &&
                          !_vm.is_admin &&
                          _vm.disableGuests
                            ? _c("q-tooltip", [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("subscription_time_limit_reached")
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ])
                            : _vm._e(),
                          !_vm.permissions.subscribe_event_users &&
                          _vm.disableGuests
                            ? _c("q-tooltip", [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "you_are_not_allowed_to_subscribe_users"
                                      )
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            color: "secondary",
                            icon: "far fa-plus",
                            label: _vm.$t("subscribe_users"),
                            disable: _vm.disableGuests
                          },
                          on: { click: _vm.showAddGuests }
                        },
                        [
                          !_vm.first_event_date
                            ? _c("q-tooltip", [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "there_are_no_events_for_this_training_yet"
                                      )
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ])
                            : _vm._e(),
                          _vm.permissions.subscribe_event_users &&
                          _vm.subscription_restrictions &&
                          !_vm.is_admin &&
                          _vm.disableGuests
                            ? _c("q-tooltip", [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t("subscription_time_limit_reached")
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ])
                            : _vm._e(),
                          !_vm.permissions.subscribe_event_users &&
                          _vm.disableGuests
                            ? _c("q-tooltip", [
                                _vm._v(
                                  "\n\t\t\t\t\t" +
                                    _vm._s(
                                      _vm.$t(
                                        "you_are_not_allowed_to_subscribe_users"
                                      )
                                    ) +
                                    "\n\t\t\t\t"
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.subscription_restrictions &&
                      !_vm.is_admin &&
                      _vm.day_before_first_event !== ""
                        ? _c("div", { staticClass: "col-12 q-pt-sm" }, [
                            _c("p", { staticClass: "text-weight-light" }, [
                              _vm._v(
                                "\n\t\t\t\t\t" +
                                  _vm._s(
                                    _vm.$t("subscription_period_until") +
                                      ": " +
                                      _vm.fDate(_vm.day_before_first_event)
                                  ) +
                                  "\n\t\t\t\t"
                              )
                            ])
                          ])
                        : _vm._e()
                    ]
                  }
                },
                {
                  key: "header",
                  fn: function(props) {
                    return _c(
                      "q-tr",
                      { attrs: { props: props } },
                      [
                        _c(
                          "q-th",
                          { attrs: { "auto-width": "" } },
                          [
                            _c("q-checkbox", {
                              attrs: {
                                "indeterminate-value": "some",
                                disable: _vm.disableGuests
                              },
                              on: {
                                input: function($event) {
                                  return _vm.selectAllGuests()
                                }
                              },
                              model: {
                                value: props.selected,
                                callback: function($$v) {
                                  _vm.$set(props, "selected", $$v)
                                },
                                expression: "props.selected"
                              }
                            })
                          ],
                          1
                        ),
                        _vm._l(props.cols, function(col) {
                          return _c(
                            "q-th",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    col.name === "status"
                                      ? _vm.showColumnGuestStatus
                                      : true,
                                  expression:
                                    "col.name === 'status' ? showColumnGuestStatus : true"
                                }
                              ],
                              key: col.name,
                              attrs: { props: props }
                            },
                            [
                              _vm._v(
                                "\n\t\t\t\t" +
                                  _vm._s(_vm.$t(col.label)) +
                                  "\n\t\t\t"
                              )
                            ]
                          )
                        })
                      ],
                      2
                    )
                  }
                },
                {
                  key: "body",
                  fn: function(props) {
                    return _c(
                      "q-tr",
                      {},
                      [
                        _c(
                          "q-td",
                          { attrs: { "auto-width": "" } },
                          [
                            _c("q-checkbox", {
                              attrs: {
                                color: "primary",
                                disable:
                                  _vm.disableGuests ||
                                  props.row.invited_and_deleted
                              },
                              model: {
                                value: props.selected,
                                callback: function($$v) {
                                  _vm.$set(props, "selected", $$v)
                                },
                                expression: "props.selected"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "q-td",
                          { key: "user_id", attrs: { props: props } },
                          [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(props.row.user_id) +
                                "\n\t\t\t"
                            )
                          ]
                        ),
                        _c(
                          "q-td",
                          { key: "full_name", attrs: { props: props } },
                          [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(props.row.full_name) +
                                "\n\t\t\t"
                            )
                          ]
                        ),
                        _c("q-td", { key: "email", attrs: { props: props } }, [
                          _vm._v(
                            "\n\t\t\t\t" + _vm._s(props.row.email) + "\n\t\t\t"
                          )
                        ]),
                        _c("q-td", { key: "phone", attrs: { props: props } }, [
                          _vm._v(
                            "\n\t\t\t\t" + _vm._s(props.row.phone) + "\n\t\t\t"
                          )
                        ]),
                        _c(
                          "q-td",
                          { key: "document", attrs: { props: props } },
                          [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(props.row.document) +
                                "\n\t\t\t"
                            )
                          ]
                        ),
                        _c(
                          "q-td",
                          { key: "branches", attrs: { props: props } },
                          [
                            props.row.branches.length > 1
                              ? _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      color: "primary",
                                      "text-color": "white",
                                      label: _vm.getQuantityBranches(
                                        props.row.branches
                                      ),
                                      "no-ripple": ""
                                    }
                                  },
                                  [
                                    _c("q-tooltip", [
                                      props.row.branches.length > 1
                                        ? _c(
                                            "p",
                                            { staticClass: "tooltip q-mb-sm" },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t" +
                                                  _vm._s(_vm.$t("branches")) +
                                                  ":\n\t\t\t\t\t\t\t"
                                              ),
                                              _vm._l(
                                                props.row.branches,
                                                function(branch, index) {
                                                  return _c(
                                                    "span",
                                                    { key: index },
                                                    [
                                                      _vm._v(
                                                        "\n\t\t\t\t\t\t\t\t" +
                                                          _vm._s(branch) +
                                                          "\n\t\t\t\t\t\t\t\t"
                                                      ),
                                                      props.row.branches
                                                        .length -
                                                        1 >
                                                      index
                                                        ? _c("span", [
                                                            _vm._v(", ")
                                                          ])
                                                        : _vm._e()
                                                    ]
                                                  )
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e(),
                            props.row.branches.length < 2
                              ? _c("span", [
                                  _vm._v(_vm._s(String(props.row.branches)))
                                ])
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "q-td",
                          { key: "areas", attrs: { props: props } },
                          [
                            props.row.areas.length > 1
                              ? _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      color: "primary",
                                      "text-color": "white",
                                      label: props.row.areas
                                        ? props.row.areas.length
                                        : 0,
                                      "no-ripple": ""
                                    }
                                  },
                                  [
                                    _c("q-tooltip", [
                                      props.row.areas.length > 1
                                        ? _c(
                                            "p",
                                            { staticClass: "tooltip q-mb-sm" },
                                            [
                                              _vm._v(
                                                "\n\t\t\t\t\t\t\t" +
                                                  _vm._s(_vm.$t("areas")) +
                                                  ":\n\t\t\t\t\t\t\t"
                                              ),
                                              _vm._l(props.row.areas, function(
                                                area,
                                                index
                                              ) {
                                                return _c(
                                                  "span",
                                                  { key: index },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.getArea(area)
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t"
                                                    ),
                                                    props.row.areas.length - 1 >
                                                    index
                                                      ? _c("span", [
                                                          _vm._v(", ")
                                                        ])
                                                      : _vm._e()
                                                  ]
                                                )
                                              })
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ])
                                  ],
                                  1
                                )
                              : _vm._e(),
                            props.row.areas.length === 1
                              ? _c("span", [
                                  _vm._v(
                                    "\n\t\t\t\t\t" +
                                      _vm._s(_vm.getArea(props.row.areas[0])) +
                                      "\n\t\t\t\t"
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "q-td",
                          { key: "profile", attrs: { props: props } },
                          [
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(
                                  _vm.translateProfiles(props.row.profile)
                                ) +
                                "\n\t\t\t"
                            )
                          ]
                        ),
                        _c(
                          "q-td",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showColumnGuestStatus,
                                expression: "showColumnGuestStatus"
                              }
                            ],
                            key: "invited_and_deleted",
                            class: props.row.invited_and_deleted
                              ? "text-negative"
                              : "",
                            attrs: { props: props }
                          },
                          [
                            props.row.invited_and_deleted &&
                            props.row.invited_and_deleted_logs
                              ? _c(
                                  "q-icon",
                                  { attrs: { name: "fal fa-plus" } },
                                  [
                                    _c(
                                      "q-tooltip",
                                      _vm._l(
                                        props.row.invited_and_deleted_logs,
                                        function(
                                          invited_and_deleted_log,
                                          index
                                        ) {
                                          return _c("span", { key: index }, [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t" +
                                                _vm._s(_vm.$t("removed_by")) +
                                                ":\n\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  invited_and_deleted_log.author_full_name
                                                ) +
                                                " " +
                                                _vm._s(_vm.$t("in")) +
                                                "\n\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.fDate(
                                                    invited_and_deleted_log.created_date
                                                  )
                                                )
                                            ),
                                            _c("br"),
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t" +
                                                _vm._s(_vm.$t("observation")) +
                                                ": " +
                                                _vm._s(
                                                  invited_and_deleted_log.observation
                                                )
                                            ),
                                            _c("br")
                                          ])
                                        }
                                      ),
                                      0
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(
                              "\n\t\t\t\t" +
                                _vm._s(
                                  props.row.invited_and_deleted
                                    ? _vm.$t("not_invited")
                                    : _vm.$t("invited")
                                ) +
                                "\n\t\t\t"
                            )
                          ],
                          1
                        ),
                        _c(
                          "q-td",
                          {
                            key: "actions",
                            attrs: { "auto-width": "", props: props }
                          },
                          [
                            _c(
                              "q-btn",
                              {
                                attrs: {
                                  round: "",
                                  flat: "",
                                  icon: "fal fa-trash",
                                  color: "negative",
                                  disable:
                                    _vm.disableRemoveGuests ||
                                    props.row.invited_and_deleted
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.confirmRemoveGuest(props)
                                  }
                                }
                              },
                              [
                                _c("q-tooltip", [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t("delete_tooltip")) +
                                      "\n\t\t\t\t\t"
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }
                }
              ],
              null,
              false,
              816326780
            )
          })
        : _vm._e(),
      _vm.presential_seats.length > 0 &&
      _vm.presential_event_contain_dates &&
      !_vm.loading_seats
        ? _c("div", { staticClass: "row gutter-sm q-mb-md" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("q-input", {
                  attrs: {
                    "float-label": _vm.$t("users_registered_for_the_event"),
                    value:
                      _vm.qty_presential_event_filled_seats +
                      "/" +
                      _vm.qty_presential_event_available_seats,
                    disable: ""
                  }
                })
              ],
              1
            ),
            _vm.qty_presential_event_filled_seats >=
            _vm.qty_presential_event_available_seats
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "q-alert",
                      {
                        staticClass: "full-width",
                        attrs: { color: "negative", icon: "fal fa-exclamation" }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(
                              _vm.$t(
                                "there_are_no_more_vacancies_for_this_event"
                              )
                            ) +
                            "\n\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm.presential_seats.length > 0 &&
      _vm.presential_event_contain_dates &&
      !_vm.loading_seats
        ? _c("div", { staticClass: "row gutter-sm" }, [
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("q-select", {
                  attrs: {
                    filter: "",
                    options: _vm.presential_seats.map(function(e) {
                      return Object.assign(
                        {},
                        {
                          value: e.tab,
                          label: e.branch_document + " - " + e.branch_name
                        },
                        e
                      )
                    }),
                    "float-label": _vm.$t("branch")
                  },
                  on: {
                    input: function($event) {
                      return _vm.loadGuests(_vm.seat_tab)
                    }
                  },
                  model: {
                    value: _vm.seat_tab,
                    callback: function($$v) {
                      _vm.seat_tab = $$v
                    },
                    expression: "seat_tab"
                  }
                })
              ],
              1
            ),
            !_vm.seat_tab_qty_available_seats_to_this_event &&
            !_vm.loading_seat_tab_users
              ? _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "q-alert",
                      {
                        staticClass: "full-width",
                        attrs: { color: "negative", icon: "fal fa-exclamation" }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(
                              _vm.$t(
                                "vacancies_already_filled_for_this_dealership_consult_planned_vacancies"
                              )
                            ) +
                            "\n\t\t\t"
                        )
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "div",
              { staticClass: "col-12" },
              [
                _c("q-table", {
                  staticClass: "q-mt-md",
                  attrs: {
                    data: _vm.seat_tab_users.filter(function(e) {
                      return (
                        e.is_invited_to_this_event ||
                        e.invited_and_deleted ||
                        _vm.getPlannedVacanciesGuestStatus(e) ===
                          "enrollment_canceled"
                      )
                    }),
                    columns: _vm.columns_users_invited,
                    "row-key": "user_id",
                    "no-data-label": _vm.$t("no_data_avaliable"),
                    "no-results-label": _vm.$t("no_results_found"),
                    "rows-per-page-label": _vm.$t("items_per_page"),
                    "loading-label": _vm.$t("loading_data"),
                    "rows-per-page-options": [5, 10, 50, 100],
                    "binary-state-sort": "",
                    loading: _vm.loading_seat_tab_users
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("guests_quantity"),
                                dense: "",
                                value:
                                  _vm.seat_tab_qty_presential_event_filled_seats +
                                  "/" +
                                  _vm.seat_tab_qty_available_seats_to_this_event,
                                disable: "",
                                readonly: ""
                              }
                            }),
                            _c("div", { staticClass: "col" }),
                            _c(
                              "q-btn",
                              {
                                attrs: {
                                  color: "secondary",
                                  icon: "far fa-plus",
                                  label: _vm.$t("subscribe_users"),
                                  disable:
                                    _vm.seat_tab_qty_available_seats_to_this_event <=
                                      _vm.seat_tab_qty_presential_event_filled_seats ||
                                    _vm.disableAddUserSeats(_vm.seat_tab)
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.showAddUserSeats(_vm.seat_tab)
                                  }
                                }
                              },
                              [
                                _vm.permissions.subscribe_event_users &&
                                _vm.subscription_restrictions &&
                                !_vm.is_admin &&
                                _vm.disableGuests
                                  ? _c("q-tooltip", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "subscription_time_limit_reached"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ])
                                  : _vm._e(),
                                !_vm.permissions.subscribe_event_users &&
                                _vm.disableGuests
                                  ? _c("q-tooltip", [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "you_are_not_allowed_to_subscribe_users"
                                            )
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ])
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm.subscription_restrictions &&
                            !_vm.is_admin &&
                            _vm.day_before_first_event !== ""
                              ? _c("div", { staticClass: "col-12 q-pt-sm" }, [
                                  _c(
                                    "p",
                                    { staticClass: "text-weight-light" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t" +
                                          _vm._s(
                                            _vm.$t(
                                              "subscription_period_until"
                                            ) +
                                              ": " +
                                              _vm.fDate(
                                                _vm.day_before_first_event
                                              )
                                          ) +
                                          "\n\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            _vm._l(props.cols, function(col) {
                              return _c(
                                "q-th",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value:
                                        col.name === "status"
                                          ? _vm.showColumnGuestStatus
                                          : true,
                                      expression:
                                        "col.name === 'status' ? showColumnGuestStatus : true"
                                    }
                                  ],
                                  key: col.name,
                                  attrs: { props: props }
                                },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(_vm.$t(col.label)) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]
                              )
                            }),
                            1
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            {},
                            [
                              _c(
                                "q-td",
                                { key: "user_id", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(props.row.user_id) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "full_name", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(props.row.full_name) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "email", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(props.row.email) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "phone", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(props.row.phone) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "document", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(props.row.document) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "branches", attrs: { props: props } },
                                [
                                  props.row.branches.length > 1
                                    ? _c(
                                        "q-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            "text-color": "white",
                                            label: _vm.getQuantityBranches(
                                              props.row.branches
                                            ),
                                            "no-ripple": ""
                                          }
                                        },
                                        [
                                          _c("q-tooltip", [
                                            props.row.branches.length > 1
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "tooltip q-mb-sm"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t("branches")
                                                        ) +
                                                        ":\n\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _vm._l(
                                                      props.row.branches,
                                                      function(branch, index) {
                                                        return _c(
                                                          "span",
                                                          { key: index },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(branch) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                                            ),
                                                            props.row.branches
                                                              .length -
                                                              1 >
                                                            index
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    ",\n\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  props.row.branches.length < 2
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(String(props.row.branches))
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "areas", attrs: { props: props } },
                                [
                                  props.row.areas.length > 1
                                    ? _c(
                                        "q-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            "text-color": "white",
                                            label: props.row.areas
                                              ? props.row.areas.length
                                              : 0,
                                            "no-ripple": ""
                                          }
                                        },
                                        [
                                          _c("q-tooltip", [
                                            props.row.areas.length > 1
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "tooltip q-mb-sm"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t("areas")
                                                        ) +
                                                        ":\n\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _vm._l(
                                                      props.row.areas,
                                                      function(area, index) {
                                                        return _c(
                                                          "span",
                                                          { key: index },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  _vm.getArea(
                                                                    area
                                                                  )
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t"
                                                            ),
                                                            props.row.areas
                                                              .length -
                                                              1 >
                                                            index
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    ",\n\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          ])
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  props.row.areas.length === 1
                                    ? _c("span", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t" +
                                            _vm._s(
                                              _vm.getArea(props.row.areas[0])
                                            ) +
                                            "\n\t\t\t\t\t\t"
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "profile", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.translateProfiles(props.row.profile)
                                      ) +
                                      "\n\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.showColumnGuestStatus,
                                      expression: "showColumnGuestStatus"
                                    }
                                  ],
                                  key: "invited_and_deleted",
                                  class: props.row.invited_and_deleted
                                    ? "text-negative"
                                    : _vm.getPlannedVacanciesGuestStatus(
                                        props.row
                                      ) === "enrollment_canceled"
                                    ? "text-negative"
                                    : "",
                                  attrs: { props: props }
                                },
                                [
                                  props.row.invited_and_deleted &&
                                  props.row.invited_and_deleted_logs
                                    ? _c(
                                        "q-icon",
                                        {
                                          staticClass: "q-pr-sm",
                                          attrs: {
                                            name: "fal fa-exclamation-triangle"
                                          }
                                        },
                                        [
                                          _c(
                                            "q-tooltip",
                                            _vm._l(
                                              props.row
                                                .invited_and_deleted_logs,
                                              function(
                                                invited_and_deleted_log,
                                                index
                                              ) {
                                                return _c(
                                                  "span",
                                                  { key: index },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t("removed_by")
                                                        ) +
                                                        ":\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          invited_and_deleted_log.author_full_name
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(_vm.$t("in")) +
                                                        "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.fDate(
                                                            invited_and_deleted_log.created_date
                                                          )
                                                        )
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t("observation")
                                                        ) +
                                                        ":\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          invited_and_deleted_log.observation
                                                        )
                                                    ),
                                                    _c("br")
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.getPlannedVacanciesGuestStatus(
                                    props.row
                                  ) === "enrollment_canceled"
                                    ? _c(
                                        "q-icon",
                                        {
                                          staticClass: "q-pr-sm",
                                          attrs: {
                                            name: "fal fa-exclamation-triangle"
                                          }
                                        },
                                        [
                                          _c(
                                            "q-tooltip",
                                            _vm._l(
                                              props.row
                                                .invited_and_deleted_logs,
                                              function(
                                                invited_and_deleted_log,
                                                index
                                              ) {
                                                return _c(
                                                  "span",
                                                  { key: index },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t("removed_by")
                                                        ) +
                                                        ":\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          invited_and_deleted_log.author_full_name
                                                        ) +
                                                        "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(_vm.$t("in")) +
                                                        "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.fDate(
                                                            invited_and_deleted_log.created_date
                                                          )
                                                        )
                                                    ),
                                                    _c("br"),
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t("observation")
                                                        ) +
                                                        ":\n\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          invited_and_deleted_log.observation
                                                        )
                                                    ),
                                                    _c("br")
                                                  ]
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(
                                    "\n\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.$t(
                                          _vm.getPlannedVacanciesGuestStatus(
                                            props.row
                                          )
                                        )
                                      ) +
                                      "\n\t\t\t\t\t"
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                {
                                  key: "actions",
                                  attrs: { "auto-width": "", props: props }
                                },
                                [
                                  _c(
                                    "q-btn",
                                    {
                                      attrs: {
                                        round: "",
                                        flat: "",
                                        icon: "fal fa-trash",
                                        color: "negative",
                                        disable:
                                          _vm.disableRemoveGuests ||
                                          props.row.invited_and_deleted
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.confirmRemoveUserInSeats(
                                            props,
                                            _vm.seat_tab
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _c("q-tooltip", [
                                        _vm._v(
                                          "\n\t\t\t\t\t\t\t\t" +
                                            _vm._s(_vm.$t("remove")) +
                                            "\n\t\t\t\t\t\t\t"
                                        )
                                      ])
                                    ],
                                    1
                                  ),
                                  _c(
                                    "q-btn",
                                    {
                                      attrs: {
                                        round: "",
                                        flat: "",
                                        icon: "fal fa-user-times",
                                        color: "secondary",
                                        disable:
                                          _vm.disableCancelSubscription ||
                                          _vm.getPlannedVacanciesGuestStatus(
                                            props.row
                                          ) === "deleted"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.cancelUserSubscription(
                                            props.row,
                                            _vm.seat_tab
                                          )
                                        }
                                      }
                                    },
                                    [
                                      props.row.invited_and_deleted
                                        ? _c("q-tooltip", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(_vm.$t("user_removed")) +
                                                "\n\t\t\t\t\t\t\t"
                                            )
                                          ])
                                        : _c("q-tooltip", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "enrollment_cancellation_request"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t"
                                            )
                                          ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }
                      }
                    ],
                    null,
                    false,
                    768143852
                  )
                })
              ],
              1
            )
          ])
        : _vm._e(),
      !_vm.loading_seats &&
      !_vm.presential_event_contain_dates &&
      _vm.presential_event_using_presential_catalog
        ? _c(
            "q-alert",
            {
              attrs: { color: "warning", icon: "fal fa-exclamation-triangle" }
            },
            [
              _vm._v(
                "\n\t\t" +
                  _vm._s(
                    _vm.$t(
                      "it_is_necessary_to_inform_event_dates_before_enrolling_students"
                    )
                  ) +
                  "\n\t"
              )
            ]
          )
        : _vm._e(),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_add_user_seats,
            callback: function($$v) {
              _vm.show_add_user_seats = $$v
            },
            expression: "show_add_user_seats"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_add_user_seats = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("guests")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    attrs: {
                      data: _vm.users_not_in_seats,
                      columns: _vm.users_not_in_seat_columns,
                      pagination: _vm.users_not_in_seat_pagination,
                      selection: "multiple",
                      selected: _vm.users_not_in_seats_selected,
                      "row-key": "user_id",
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      "binary-state-sort": "",
                      "hide-bottom": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.users_not_in_seat_pagination = $event
                      },
                      "update:selected": function($event) {
                        _vm.users_not_in_seats_selected = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("div", { staticClass: "col" }),
                            _vm.users_not_in_seats_selected.length > 0
                              ? _c(
                                  "q-btn",
                                  {
                                    attrs: {
                                      color: "positive",
                                      icon: "far fa-plus",
                                      label: _vm.$t("subscribe_users"),
                                      disable: _vm.checkAddUserNotInSeats()
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.addUserNotInSeats()
                                      }
                                    }
                                  },
                                  [
                                    _vm.checkAddUserNotInSeats()
                                      ? _c("q-tooltip", [
                                          _vm._v(
                                            "\n\t\t\t\t\t\t\t\t" +
                                              _vm._s(
                                                _vm.$t(
                                                  "the_number_of_users_selected_is_greater_than_the_number_of_places_available"
                                                )
                                              ) +
                                              "\n\t\t\t\t\t\t\t"
                                          )
                                        ])
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-th",
                                { attrs: { "auto-width": "" } },
                                [
                                  _c("q-checkbox", {
                                    attrs: { "indeterminate-value": "some" },
                                    on: {
                                      input: function($event) {
                                        return _vm.selectAllNotInSeats()
                                      }
                                    },
                                    model: {
                                      value: props.selected,
                                      callback: function($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._l(props.cols, function(col) {
                                return _c(
                                  "q-th",
                                  { key: col.name, attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t(col.label)) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-td",
                                { attrs: { "auto-width": "" } },
                                [
                                  _c(
                                    "q-checkbox",
                                    {
                                      attrs: {
                                        color: "primary",
                                        disable: props.row
                                          .allowed_to_be_invited_to_this_event
                                          ? false
                                          : true
                                      },
                                      model: {
                                        value: props.selected,
                                        callback: function($$v) {
                                          _vm.$set(props, "selected", $$v)
                                        },
                                        expression: "props.selected"
                                      }
                                    },
                                    [
                                      !props.row
                                        .allowed_to_be_invited_to_this_event
                                        ? _c("q-tooltip", [
                                            _vm._v(
                                              "\n\t\t\t\t\t\t\t\t\t" +
                                                _vm._s(
                                                  _vm.$t(
                                                    "user_already_certified_or_invited_to_another_event"
                                                  )
                                                ) +
                                                "\n\t\t\t\t\t\t\t\t"
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "user_id", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.user_id) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "full_name", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.full_name) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "email", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.email) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "branches", attrs: { props: props } },
                                [
                                  props.row.branches.length > 1
                                    ? _c(
                                        "q-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            "text-color": "white",
                                            label: _vm.getQuantityBranches(
                                              props.row.branches
                                            ),
                                            "no-ripple": ""
                                          }
                                        },
                                        [
                                          props.row.branches.length > 1
                                            ? _c("q-tooltip", [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "tooltip q-mb-sm"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t("branches")
                                                        ) +
                                                        ":\n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _vm._l(
                                                      props.row.branches,
                                                      function(branch, index) {
                                                        return _c(
                                                          "span",
                                                          { key: index },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(branch) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            ),
                                                            props.row.branches
                                                              .length -
                                                              1 >
                                                            index
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    ",\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ])
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  props.row.branches.length < 2
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(String(props.row.branches))
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "profile", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.translateProfiles(props.row.profile)
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_guests,
            callback: function($$v) {
              _vm.show_guests = $$v
            },
            expression: "show_guests"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: { click: _vm.closeGuestModal }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.$t("guests")) + "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("q-table", {
                    attrs: {
                      data: _vm.guests_list,
                      columns: _vm.guests_columns,
                      pagination: _vm.new_guests_pagination,
                      filter: _vm.filter_guests,
                      loading: _vm.loading,
                      selection: "multiple",
                      selected: _vm.users_invited_selected,
                      "row-key": "id",
                      "no-data-label": _vm.$t("no_data_avaliable"),
                      "no-results-label": _vm.$t("no_results_found"),
                      "loading-label": _vm.$t("loading_data"),
                      "rows-per-page-label": _vm.$t("items_per_page"),
                      "rows-per-page-options": [5, 10, 50, 100],
                      "binary-state-sort": ""
                    },
                    on: {
                      "update:pagination": function($event) {
                        _vm.new_guests_pagination = $event
                      },
                      request: _vm.requestNewGuests,
                      "update:selected": function($event) {
                        _vm.users_invited_selected = $event
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "top",
                        fn: function(props) {
                          return [
                            _c("q-search", {
                              staticClass: "q-mr-lg",
                              attrs: {
                                icon: "far fa-search",
                                placeholder: _vm.$t("search"),
                                "float-label": _vm.$t("search"),
                                debounce: 600
                              },
                              model: {
                                value: _vm.filter_guests,
                                callback: function($$v) {
                                  _vm.filter_guests = $$v
                                },
                                expression: "filter_guests"
                              }
                            }),
                            _c("q-select", {
                              staticClass: "q-mr-md",
                              attrs: {
                                chips: "",
                                multiple: "",
                                options: _vm.getAllowedAreas,
                                "float-label": _vm.$t("area")
                              },
                              on: {
                                input: function($event) {
                                  return _vm.changeAddFilter()
                                }
                              },
                              model: {
                                value: _vm.area,
                                callback: function($$v) {
                                  _vm.area = $$v
                                },
                                expression: "area"
                              }
                            }),
                            _c("q-select", {
                              staticClass: "q-mr-md",
                              attrs: {
                                chips: "",
                                multiple: "",
                                options: _vm.getAllowedProfiles,
                                "float-label": _vm.$t("profiles")
                              },
                              on: {
                                input: function($event) {
                                  return _vm.changeAddFilter()
                                }
                              },
                              model: {
                                value: _vm.profile,
                                callback: function($$v) {
                                  _vm.profile = $$v
                                },
                                expression: "profile"
                              }
                            }),
                            _vm.current_client === "academiacoral"
                              ? _c(
                                  "q-input",
                                  {
                                    ref: "branches",
                                    staticClass: "q-mr-md",
                                    attrs: {
                                      "float-label": _vm.$t("branches"),
                                      "value-field": function(v) {
                                        return "" + v.label
                                      },
                                      debounce: 600,
                                      clearable: ""
                                    },
                                    on: { clear: _vm.clearAutoComplete },
                                    model: {
                                      value: _vm.branches,
                                      callback: function($$v) {
                                        _vm.branches = $$v
                                      },
                                      expression: "branches"
                                    }
                                  },
                                  [
                                    _c("q-autocomplete", {
                                      attrs: {
                                        "min-characters": 3,
                                        separator: ""
                                      },
                                      on: {
                                        search: _vm.fetchBranches,
                                        selected: _vm.selectedBranch
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.current_client === "academiacoral"
                              ? _c(
                                  "q-input",
                                  {
                                    ref: "company",
                                    attrs: {
                                      "float-label": _vm.$t("company"),
                                      debounce: 600,
                                      clearable: ""
                                    },
                                    on: { clear: _vm.clearAutoComplete },
                                    model: {
                                      value: _vm.companies,
                                      callback: function($$v) {
                                        _vm.companies = $$v
                                      },
                                      expression: "companies"
                                    }
                                  },
                                  [
                                    _c("q-autocomplete", {
                                      attrs: {
                                        "min-characters": 3,
                                        separator: ""
                                      },
                                      on: {
                                        search: _vm.fetchCompanies,
                                        selected: _vm.selectedCompany
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c("div", { staticClass: "col" }),
                            _vm.users_invited_selected.length > 0
                              ? _c("q-btn", {
                                  attrs: {
                                    color: "positive",
                                    icon: "far fa-plus",
                                    label: _vm.$t("subscribe_users")
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.addGuests()
                                    }
                                  }
                                })
                              : _vm._e()
                          ]
                        }
                      },
                      {
                        key: "header",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-th",
                                { attrs: { "auto-width": "" } },
                                [
                                  _c("q-checkbox", {
                                    attrs: { "indeterminate-value": "some" },
                                    model: {
                                      value: props.selected,
                                      callback: function($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._l(props.cols, function(col) {
                                return _c(
                                  "q-th",
                                  { key: col.name, attrs: { props: props } },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t" +
                                        _vm._s(_vm.$t(col.label)) +
                                        "\n\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                        }
                      },
                      {
                        key: "body",
                        fn: function(props) {
                          return _c(
                            "q-tr",
                            { attrs: { props: props } },
                            [
                              _c(
                                "q-td",
                                { attrs: { "auto-width": "" } },
                                [
                                  _c("q-checkbox", {
                                    attrs: { color: "primary" },
                                    model: {
                                      value: props.selected,
                                      callback: function($$v) {
                                        _vm.$set(props, "selected", $$v)
                                      },
                                      expression: "props.selected"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "id", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.id) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "full_name", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.full_name) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "email", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(props.row.email) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              ),
                              _c(
                                "q-td",
                                { key: "branches", attrs: { props: props } },
                                [
                                  props.row.branches.length > 1
                                    ? _c(
                                        "q-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            "text-color": "white",
                                            label: _vm.getQuantityBranches(
                                              props.row.branches
                                            ),
                                            "no-ripple": ""
                                          }
                                        },
                                        [
                                          props.row.branches.length > 1
                                            ? _c("q-tooltip", [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "tooltip q-mb-sm"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t("branches")
                                                        ) +
                                                        ":\n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _vm._l(
                                                      props.row.branches,
                                                      function(branch, index) {
                                                        return _c(
                                                          "span",
                                                          { key: index },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(branch) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            ),
                                                            props.row.branches
                                                              .length -
                                                              1 >
                                                            index
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    ",\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ])
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  props.row.branches.length < 2
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(String(props.row.branches))
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "companies", attrs: { props: props } },
                                [
                                  props.row.companies.length > 1
                                    ? _c(
                                        "q-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            "text-color": "white",
                                            label: _vm.getQuantityCompanies(
                                              props.row.companies
                                            ),
                                            "no-ripple": ""
                                          }
                                        },
                                        [
                                          props.row.companies.length > 1
                                            ? _c("q-tooltip", [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "tooltip q-mb-sm"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n\t\t\t\t\t\t\t\t\t\t" +
                                                        _vm._s(
                                                          _vm.$t("company")
                                                        ) +
                                                        ":\n\t\t\t\t\t\t\t\t\t\t"
                                                    ),
                                                    _vm._l(
                                                      props.row.companies,
                                                      function(company, index) {
                                                        return _c(
                                                          "span",
                                                          { key: index },
                                                          [
                                                            _vm._v(
                                                              "\n\t\t\t\t\t\t\t\t\t\t\t" +
                                                                _vm._s(
                                                                  company
                                                                ) +
                                                                "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                            ),
                                                            props.row.companies
                                                              .length -
                                                              1 >
                                                            index
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    ",\n\t\t\t\t\t\t\t\t\t\t\t"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        )
                                                      }
                                                    )
                                                  ],
                                                  2
                                                )
                                              ])
                                            : _vm._e()
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  props.row.branches.length < 2
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(String(props.row.branches))
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c(
                                "q-td",
                                { key: "profile", attrs: { props: props } },
                                [
                                  _vm._v(
                                    "\n\t\t\t\t\t\t\t" +
                                      _vm._s(
                                        _vm.translateProfiles(props.row.profile)
                                      ) +
                                      "\n\t\t\t\t\t\t"
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_guests_import,
            callback: function($$v) {
              _vm.show_guests_import = $$v
            },
            expression: "show_guests_import"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        _vm.show_guests_import = false
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("import_guests")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c(
                    "p",
                    { staticClass: "q-mb-none text-weight-light q-mb-md" },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("guests_import_template_start")) +
                          "\n\t\t\t\t\t"
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "text-weight-medium cursor-pointer",
                          on: {
                            click: function($event) {
                              return _vm.getTemplate()
                            }
                          }
                        },
                        [_vm._v("presential_event_users.xlsx")]
                      ),
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.$t("guests_import_template_end")) +
                          "\n\t\t\t\t"
                      )
                    ]
                  ),
                  _c("uploader", {
                    attrs: {
                      content_type: "xlsx",
                      multiple: false,
                      cropper: false
                    },
                    on: { fileUploaded: _vm.userImportUpload }
                  }),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm justify-end q-mt-lg" },
                    [
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-3" },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "negative",
                              label: _vm.$t("cancel"),
                              icon: "far fa-times"
                            },
                            on: {
                              click: function($event) {
                                _vm.show_guests_import = false
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "col-xs-12 col-sm-3" },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "secondary",
                              label: _vm.$t("save"),
                              icon: "far fa-save"
                            },
                            on: {
                              click: function($event) {
                                return _vm.importUser()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "80vh"
            }
          },
          model: {
            value: _vm.show_create_users,
            callback: function($$v) {
              _vm.show_create_users = $$v
            },
            expression: "show_create_users"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideCreateUsers()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.$t("new_users")) +
                        "\n\t\t\t\t"
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "layout-padding" },
                [
                  _c("div", { staticClass: "row gutter-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.new_user.email_error,
                              "error-label": _vm.new_user.email_error
                                ? "" + _vm.$t("email_not_unique")
                                : ""
                            }
                          },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("email"),
                                error: _vm.$v.new_user.email.$error,
                                disable: !this.register_fields.email_fields
                              },
                              on: {
                                input: _vm.$v.new_user.email.$touch,
                                blur: function($event) {
                                  return _vm.emailUnique()
                                }
                              },
                              model: {
                                value: _vm.new_user.email,
                                callback: function($$v) {
                                  _vm.$set(_vm.new_user, "email", $$v)
                                },
                                expression: "new_user.email"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              error: _vm.new_user.document_error,
                              "error-label": _vm.new_user.document_error
                                ? _vm.$t("document_not_unique")
                                : ""
                            }
                          },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("document"),
                                error: _vm.$v.new_user.document.$error
                              },
                              on: {
                                input: _vm.$v.new_user.document.$touch,
                                blur: function($event) {
                                  return _vm.documentUnique()
                                }
                              },
                              model: {
                                value: _vm.new_user.document,
                                callback: function($$v) {
                                  _vm.$set(_vm.new_user, "document", $$v)
                                },
                                expression: "new_user.document"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-2" },
                      [
                        _c("q-select", {
                          attrs: {
                            "float-label": _vm.$t("profile"),
                            options: _vm.register_profiles,
                            error: _vm.$v.new_user.profile.$error
                          },
                          on: { input: _vm.$v.new_user.profile.$touch },
                          model: {
                            value: _vm.new_user.profile,
                            callback: function($$v) {
                              _vm.$set(_vm.new_user, "profile", $$v)
                            },
                            expression: "new_user.profile"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("full_name"),
                            error: _vm.$v.new_user.full_name.$error
                          },
                          on: { input: _vm.$v.new_user.full_name.$touch },
                          model: {
                            value: _vm.new_user.full_name,
                            callback: function($$v) {
                              _vm.$set(_vm.new_user, "full_name", $$v)
                            },
                            expression: "new_user.full_name"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-1" },
                      [
                        _c("q-btn", {
                          staticClass: "q-mt-md",
                          attrs: {
                            round: "",
                            flat: "",
                            color: "positive",
                            icon: "fal fa-plus"
                          },
                          on: {
                            click: function($event) {
                              return _vm.addNewUser()
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._l(_vm.new_users, function(user, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "row gutter-sm" },
                      [
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("email"),
                                disable: ""
                              },
                              model: {
                                value: user.email,
                                callback: function($$v) {
                                  _vm.$set(user, "email", $$v)
                                },
                                expression: "user.email"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("document"),
                                disable: ""
                              },
                              model: {
                                value: user.document,
                                callback: function($$v) {
                                  _vm.$set(user, "document", $$v)
                                },
                                expression: "user.document"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-2" },
                          [
                            _c("q-select", {
                              attrs: {
                                "float-label": _vm.$t("profile"),
                                options: _vm.register_profiles,
                                disable: ""
                              },
                              model: {
                                value: user.profile,
                                callback: function($$v) {
                                  _vm.$set(user, "profile", $$v)
                                },
                                expression: "user.profile"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-3" },
                          [
                            _c("q-input", {
                              attrs: {
                                "float-label": _vm.$t("full_name"),
                                disable: ""
                              },
                              model: {
                                value: user.full_name,
                                callback: function($$v) {
                                  _vm.$set(user, "full_name", $$v)
                                },
                                expression: "user.full_name"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-xs-12 col-sm-1" },
                          [
                            _c("q-btn", {
                              staticClass: "q-mt-md",
                              attrs: {
                                color: "negative",
                                round: "",
                                flat: "",
                                icon: "fal fa-trash"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeNewUser(index)
                                }
                              }
                            })
                          ],
                          1
                        )
                      ]
                    )
                  }),
                  _c(
                    "div",
                    { staticClass: "row gutter-sm justify-end q-mt-lg" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("cancel")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "tertiary",
                              label: _vm.$t("cancel"),
                              icon: "far fa-chevron-left"
                            },
                            on: {
                              click: function($event) {
                                return _vm.hideCreateUsers()
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "col-xs-12 col-sm-3",
                          class: _vm.getOrder("save")
                        },
                        [
                          _c("q-btn", {
                            staticClass: "full-width",
                            attrs: {
                              color: "secondary",
                              label: _vm.$t("save_new_users"),
                              icon: "far fa-save",
                              disable: _vm.new_users.length === 0 ? true : false
                            },
                            on: {
                              click: function($event) {
                                return _vm.saveNewUsers()
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("close") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove_guest = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeGuest()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove_guest,
            callback: function($$v) {
              _vm.confirm_remove_guest = $$v
            },
            expression: "confirm_remove_guest"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_guest")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("do_you_want_to_remove_this_guest")))
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-input", {
                attrs: { type: "textarea", placeholder: _vm.$t("observation") },
                model: {
                  value: _vm.confirm_remove_guests_observation,
                  callback: function($$v) {
                    _vm.confirm_remove_guests_observation = $$v
                  },
                  expression: "confirm_remove_guests_observation"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("close") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove_guests = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeGuests()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove_guests,
            callback: function($$v) {
              _vm.confirm_remove_guests = $$v
            },
            expression: "confirm_remove_guests"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_guests")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("do_you_want_to_remove_the_selected_guests")))
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-input", {
                attrs: { type: "textarea", placeholder: _vm.$t("observation") },
                model: {
                  value: _vm.confirm_remove_guests_observation,
                  callback: function($$v) {
                    _vm.confirm_remove_guests_observation = $$v
                  },
                  expression: "confirm_remove_guests_observation"
                }
              })
            ],
            1
          )
        ]
      ),
      _c(
        "q-dialog",
        {
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("close") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove_user_in_seats = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeUserInSeats()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove_user_in_seats,
            callback: function($$v) {
              _vm.confirm_remove_user_in_seats = $$v
            },
            expression: "confirm_remove_user_in_seats"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_guest")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("do_you_want_to_remove_this_guest")))
          ]),
          _c(
            "div",
            { attrs: { slot: "body" }, slot: "body" },
            [
              _c("q-input", {
                attrs: { type: "textarea", placeholder: _vm.$t("observation") },
                model: {
                  value: _vm.confirm_remove_guests_observation,
                  callback: function($$v) {
                    _vm.confirm_remove_guests_observation = $$v
                  },
                  expression: "confirm_remove_guests_observation"
                }
              })
            ],
            1
          )
        ]
      ),
      _c("cancel-subscription", {
        attrs: {
          show_subscription_history: _vm.show_subscription_history,
          presential_event_id: _vm.presential_event_id,
          user: _vm.user_to_cancel_subscription,
          allow_enrollment_cancellation: _vm.allow_enrollment_cancellation
        },
        on: {
          save_cancellation_and_load_guests: _vm.saveCancellationAndLoadGuests,
          hide_subscription_history: function($event) {
            return _vm.hideSubscriptionHistory()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }